import { MutationOptions, QueryOptions } from '@apollo/client';
import { MarketType } from 'constants/markets';
import { apolloClientServer } from 'server/apolloClientServer';

export function query<T>(market: MarketType, options: QueryOptions) {
    return apolloClientServer(market).query<T>(options);
}

export function mutate<T>(market: MarketType, options: MutationOptions) {
    return apolloClientServer(market).mutate<T>(options);
}
